export enum ApprovalStatus {
    Positive = "Positive",
    Neutral = "Neutral",
    Negative = "Negative"
}
